/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartnerEmailInput } from './PartnerEmailInput';
import {
    PartnerEmailInputFromJSON,
    PartnerEmailInputFromJSONTyped,
    PartnerEmailInputToJSON,
    PartnerEmailInputToJSONTyped,
} from './PartnerEmailInput';

/**
 * 
 * @export
 * @interface GenerateEmailRequest
 */
export interface GenerateEmailRequest {
    /**
     * indicates if the prospect accepted the terms and condition
     * @type {boolean}
     * @memberof GenerateEmailRequest
     */
    termsAndCondition?: boolean;
    /**
     * 
     * @type {PartnerEmailInput}
     * @memberof GenerateEmailRequest
     */
    partnerEmail?: PartnerEmailInput;
}

/**
 * Check if a given object implements the GenerateEmailRequest interface.
 */
export function instanceOfGenerateEmailRequest(value: object): value is GenerateEmailRequest {
    return true;
}

export function GenerateEmailRequestFromJSON(json: any): GenerateEmailRequest {
    return GenerateEmailRequestFromJSONTyped(json, false);
}

export function GenerateEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateEmailRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'termsAndCondition': json['termsAndCondition'] == null ? undefined : json['termsAndCondition'],
        'partnerEmail': json['PartnerEmail'] == null ? undefined : PartnerEmailInputFromJSON(json['PartnerEmail']),
    };
}

export function GenerateEmailRequestToJSON(json: any): GenerateEmailRequest {
    return GenerateEmailRequestToJSONTyped(json, false);
}

export function GenerateEmailRequestToJSONTyped(value?: GenerateEmailRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'termsAndCondition': value['termsAndCondition'],
        'PartnerEmail': PartnerEmailInputToJSON(value['partnerEmail']),
    };
}

